import * as React from 'react'

const WelcomerIcon = (props: any) => (
  <svg data-name="Component 127 \u2013 1" xmlns="http://www.w3.org/2000/svg" width={56} height={56} {...props}>
    <defs>
      <clipPath id="WelcomerIcon">
        <path data-name="Path 91599" d="M0 0h32v32H0Z" transform="translate(213 1858)" fill="none" stroke="#707070" />
      </clipPath>
    </defs>
    <rect data-name="Rectangle 7670" width={56} height={56} rx={28} fill="#ffefed" />
    <g data-name="Mask Group 807" transform="translate(-201 -1846)" clipPath="url(#WelcomerIcon)">
      <g data-name="Group 58779" fill="#263238">
        <g data-name="Group 58782">
          <path
            data-name="Path 91587"
            d="M237.138 1882.935h-2.147v-1.2h2.147a.4.4 0 0 0 .4-.4v-4.814h-2.213v-1.2h3.413v6.014a1.6 1.6 0 0 1-1.6 1.6Z"
          />
          <path
            data-name="Path 91589"
            d="M223.085 1882.935h-2.147a1.6 1.6 0 0 1-1.6-1.6v-6.014h3.414v1.2h-2.214v4.814a.4.4 0 0 0 .4.4h2.147Z"
          />
        </g>
        <path data-name="Path 91588" d="M236.005 1883.769h-13.861v-10.073h1.2v8.872h11.461v-8.872h1.2Z" />
        <path
          data-name="Path 91590"
          d="M232.745 1867.331h-1.2a1.9 1.9 0 0 0-1.9-1.9h-.854a1.9 1.9 0 0 0-1.9 1.9h-1.2a3.1 3.1 0 0 1 3.1-3.1h.854a3.1 3.1 0 0 1 3.1 3.1Z"
        />
        <path
          data-name="Rectangle 10115"
          d="M222.145 1867.582v3.347a2.8 2.8 0 0 0 2.8 2.8h8.188a2.8 2.8 0 0 0 2.8-2.8v-3.347h-13.788m-1.2-1.2h16.188v4.547a4 4 0 0 1-4 4h-8.188a4 4 0 0 1-4-4Z"
        />
        <path data-name="Line 2687" d="M232.548 1877.511h-1.2v-5.248h1.2Z" />
        <path data-name="Line 2688" d="M227.075 1877.511h-1.2v-5.248h1.2Z" />
      </g>
    </g>
  </svg>
)

export default WelcomerIcon
